import React from 'react';
import { Card } from 'react-bootstrap';
import { currencyFormatter } from '../../../utils/services';
import { Link } from 'react-router-dom';

const PendingClassification = ({ totalExpenses, compact = false }) => {
  const hasPendingAmount = totalExpenses < 0;
  const cardText = hasPendingAmount
    ? `${currencyFormatter.format(totalExpenses)} Pendiente por clasificar`
    : (compact ? 'Sin gastos por clasificar' : 'No tienes gastos pendientes por clasificar');

  return (
    <Link to="/expenses" className="text-white" style={{ textDecoration: 'none' }}>
      <Card
        className={`text-center text-white ${hasPendingAmount ? 'bg-danger' : 'bg-success'} ${compact ? 'mb-0' : 'mb-4'}`}
      >
        <Card.Body className={compact ? 'py-1 px-3' : undefined}>
          <Card.Title as={compact ? 'h6' : 'h5'} className={compact ? 'mb-0 text-nowrap' : undefined}>
            {cardText}
          </Card.Title>
        </Card.Body>
      </Card>
    </Link>
  );
};

export default PendingClassification;